import { defineMessages } from 'react-intl';

const messages = defineMessages({
  inLibrary: {
    id: 'pickandmixhelper.inLibrary',
    defaultMessage: 'In Library',
  },
  inSteamLibrary: {
    id: 'pickandmixhelper.inSteamLibrary',
    defaultMessage: 'In Steam Library',
  },
  lowStock: {
    id: 'pickandmixhelper.lowStock',
    defaultMessage: 'Low Stock',
  },
  soldOut: {
    id: 'pickandmixhelper.soldOut',
    defaultMessage: 'Sold Out',
  },
  all: {
    id: 'pickandmixhelper.all',
    defaultMessage: 'All',
  },
  recommended: {
    id: 'pickandmixhelper.recommended',
    defaultMessage: 'Recommended',
  },
  recommendedForYou: {
    id: 'pickandmixhelper.recommendedForYou',
    defaultMessage: 'Recommended For You',
  },
  recommendedForYouDesc: {
    id: 'pickandmixhelper.recommendedForYouDesc',
    defaultMessage: 'Explore a curated selection recommended for you',
  },
  steamdeckverified: {
    id: 'pickandmixhelper.steamdeckverified',
    defaultMessage: 'Steam Deck Verified',
  },
  steamdeckverifiedDesc: {
    id: 'pickandmixhelper.steamdeckverifiedDesc',
    defaultMessage: 'Optimised for your Steam Deck! Enjoy a selection of titles fully verified to play on the go.',
  },
  bestSaving: {
    id: 'pickandmixhelper.bestSaving',
    defaultMessage: 'Best Saving',
  },
  bestSavingDesc: {
    id: 'pickandmixhelper.bestSavingDesc',
    defaultMessage: 'Enjoy unbeatable savings with this collection of top picks at a fantastic price',
  },
  remove: {
    id: 'pickandmixhelper.remove',
    defaultMessage: 'Remove from cart',
  },
  viewBundle: {
    id: 'pickandmixhelper.viewBundle',
    defaultMessage: 'View Bundle',
  },
  fanFavourites: {
    id: 'pickandmixhelper.fanFavourites',
    defaultMessage: 'Fan Favourites',
  },
  fanFavouritesDesc: {
    id: 'pickandmixhelper.fanFavouritesDesc',
    defaultMessage: 'Discover the most popular picks from the community',
  },
  criticallyAcclaimed: {
    id: 'pickandmixhelper.criticallyAcclaimed',
    defaultMessage: 'Critically Acclaimed',
  },
  criticallyAcclaimedDesc: {
    id: 'pickandmixhelper.criticallyAcclaimedDesc',
    defaultMessage: 'Explore the best of the best, as rated by critics',
  },
  categoriesBundleTitle: {
    id: 'pickandmixhelper.bundletitle',
    defaultMessage: '{categoryName} Bundle',
  },
  categoriesDesc: {
    id: 'pickandmixhelper.gamesDesc',
    defaultMessage: 'Explore a top selection of {categoryName} titles, perfect for fans of the genre',
  },
  publishersDesc: {
    id: 'pickandmixhelper.publishersDesc',
    defaultMessage: 'Explore a diverse lineup from {categoryName}, featuring a range of popular and acclaimed titles',
  },

  franchisesDesc: {
    id: 'pickandmixhelper.franchisesDesc',
    defaultMessage: 'Immerse yourself in the world of {categoryName} with this curated collection of fan-favorite titles.',
  },
  games: {
    id: 'pickandmixhelper.games',
    defaultMessage: 'Games',
  },
  products: {
    id: 'pickandmixhelper.products',
    defaultMessage: 'Products',
  },
  dlcs: {
    id: 'pickandmixhelper.dlcs',
    defaultMessage: 'DLCs',
  },
  pickForMeDesc: {
    id: 'pickandmixhelper.pickForMeRecommendationMessage',
    defaultMessage: 'Here are our recommendations to you. Add them to your cart or pick again to see something new.',
  },
  pickForMeDescBased: {
    id: 'pickandmixhelper.pickForMeDescBased',
    defaultMessage: 'Here are our recommendations to you based on {categoryName}. Add them to your cart or pick again to see something new.',
  },
  pickForMeDescBasedBundleType: {
    id: 'pickandmixhelper.pickForMeDescBasedBundleType',
    defaultMessage: 'Here are our recommendations to you based on {categoryName} {bundleType}. Add them to your cart or pick again to see something new.',
  },
  pickForMeDescFrom: {
    id: 'pickandmixhelper.pickForMeDescFrom',
    defaultMessage: 'Here are our recommendations to you from {categoryName}. Add them to your cart or pick again to see something new.',
  },
});

export default messages;
